import { Checkbox } from '@zoopla-eng/zds/checkbox';
import { Stack } from '@zoopla-eng/zds/stack';
import { checkboxContainerStyle } from './Modal.styles.css';

const features = [
    'has_garden',
    'has_parking_garage',
    'has_balcony_terrace'
] as const;

const featureLabels = {
    has_balcony_terrace: 'Balcony/terrace',
    has_garden: 'Garden',
    has_parking_garage: 'Parking/garage'
};

export type Features = Array<typeof features[number]>;

type FeatureProps = {
    value: Features;
    onChange: (feature: Features) => void;
};

export const Features = ({ value, onChange }: FeatureProps) => {
    return (
        <Stack flexDirection="row" flexWrap="wrap" columnGap={0} rowGap="S400">
            {features.map((feature, index) => {
                return (
                    <div
                        className={checkboxContainerStyle}
                        key={`${feature}-${index}-container`}
                    >
                        <Checkbox
                            key={`${feature}-${index}`}
                            name={feature}
                            label={featureLabels[feature]}
                            checked={value.includes(feature)}
                            onCheckedChange={(checked) => {
                                if (checked) {
                                    onChange([...value, feature]);
                                } else {
                                    onChange(
                                        value.filter((i) => i !== feature)
                                    );
                                }
                            }}
                        />
                    </div>
                );
            })}
        </Stack>
    );
};
